import styled, { rem } from '@nobia/zeus-components/lib/styled'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'

import { Image } from '../image/Image'
import { Heading2, Paragraph } from '../typography'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: block;
  cursor: pointer;
`

const ImageOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 ${rem(50)};
`

const Preamble = styled(Paragraph)`
  color: #fff;
  font-size: ${rem(16)};
  line-height: 38px;
  font-weight: ${(p) => p.theme.typography.paragraph.fontWeight};
`

const Title = styled(Heading2)`
  color: #fff;
  font-size: 30px;
  line-height: 38px;
  margin-bottom: 0;
`

const Link = styled.p`
  color: #fff;
  font-size: ${rem(16)};
  line-height: 38px;
  font-weight: ${(p) => p.theme.typography.link.fontWeight};
  margin: 0;
  text-decoration: underline;
`

const CampaignImage = ({ title, preamble, text, image }) => {
  const textOverlay = title || preamble || text
  return (
    <>
      <Image publicId={image} />
      {textOverlay ? (
        <ImageOverlay>
          {preamble ? <Preamble>{preamble}</Preamble> : null}
          {title ? <Title>{title}</Title> : null}
          {text ? <Link>{text}</Link> : null}
        </ImageOverlay>
      ) : null}
    </>
  )
}

CampaignImage.defaultProps = {
  title: '',
  preamble: '',
  text: '',
  image: '',
}

CampaignImage.propTypes = {
  title: PropTypes.string,
  preamble: PropTypes.string,
  text: PropTypes.string,
  image: PropTypes.string,
}

export const Campaign = ({ title, preamble, text, image, link, onClick }) => {
  const handleClick = useCallback(
    (event) => {
      onClick(event)
    },
    [onClick]
  )

  if (link) {
    return (
      <Wrapper as="a" href={link} target="_blank">
        <CampaignImage
          image={image}
          title={title}
          preamble={preamble}
          text={text}
        />
      </Wrapper>
    )
  }

  if (onClick) {
    return (
      <Wrapper onClick={handleClick}>
        <CampaignImage
          image={image}
          title={title}
          preamble={preamble}
          text={text}
        />
      </Wrapper>
    )
  }

  return null
}

Campaign.defaultProps = {
  title: '',
  preamble: '',
  text: '',
  link: '',
  image: '',
  onClick: () => null,
}

Campaign.propTypes = {
  title: PropTypes.string,
  preamble: PropTypes.string,
  text: PropTypes.string,
  link: PropTypes.string,
  image: PropTypes.string,
  onClick: PropTypes.func,
}
